

































import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { HsabExpenseResponse } from "@/shared/types";
import Paginator from "@/shared/components/ui/Paginator.vue";
import HsabExpenseCardRow from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRow.vue";
import HsabExpenseCardColumns from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardColumns.vue";

@Component({
  components: {
    HsabExpenseCardRow,
    Paginator,
    GenericLoadingSpinner,
    HsabExpenseCardColumns,
  }
})
export default class HsabExpenseTable extends Vue {

  @Prop()
  isSubmittedExpenses: boolean;

  @Prop()
  title: string;

  @Prop()
  loaded: boolean;

  @Prop()
  items: HsabExpenseResponse[];

  @Prop()
  totalCount: number;

  @Prop()
  hasPages: boolean;

  @Prop()
  currentPage: number;

  @Prop()
  pageCount: number;

  @Prop()
  pageRange: any[];

  @Prop()
  isInTab: boolean;

  onSwitchPage (pageNumber: number) {
    this.$emit("switchPage", pageNumber);
  }

}
